// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file social/chat/entity/v2/member.proto (package social.chat.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { VerifiedStatus } from "../../../verified_badge/enum/v1/verified_status_pb.js";
import { RoomState } from "./room_pb.js";

/**
 * @generated from enum social.chat.entity.v2.MemberRole
 */
export const MemberRole = /*@__PURE__*/ proto3.makeEnum(
  "social.chat.entity.v2.MemberRole",
  [
    {no: 0, name: "MEMBER_ROLE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MEMBER_ROLE_NORMAL", localName: "NORMAL"},
    {no: 2, name: "MEMBER_ROLE_ADMIN", localName: "ADMIN"},
  ],
);

/**
 * @generated from message social.chat.entity.v2.MemberUser
 */
export const MemberUser = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MemberUser",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "username", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "avatar", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "member_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "verified_status", kind: "enum", T: proto3.getEnumType(VerifiedStatus) },
  ],
);

/**
 * @generated from message social.chat.entity.v2.GroupMember
 */
export const GroupMember = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.GroupMember",
  () => [
    { no: 1, name: "user", kind: "message", T: MemberUser },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(MemberRole) },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(RoomState) },
    { no: 4, name: "is_interactable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MemberUserData
 */
export const MemberUserData = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MemberUserData",
  () => [
    { no: 1, name: "member_info", kind: "message", T: MemberUser },
    { no: 2, name: "is_group_member", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.MemberStats
 */
export const MemberStats = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.MemberStats",
  () => [
    { no: 1, name: "capacity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "current", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "available", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "active", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message social.chat.entity.v2.AdminStats
 */
export const AdminStats = /*@__PURE__*/ proto3.makeMessageType(
  "social.chat.entity.v2.AdminStats",
  () => [
    { no: 1, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

